import React, { FC, useState } from 'react';
import { Box } from '@material-ui/core';
import { Collapse } from 'react-collapse';
import { useStyles } from './styles';
import { ReactComponent as ArrowSVG } from './assets/arrow.svg';
import { ExpansionPanelProps } from './interface';
import './expansionPanel.css';

export const ExpansionPanel: FC<ExpansionPanelProps> = ({ title, content }) => {
  const [open, setOpen] = useState(false);
  const classes = useStyles();

  const onOpen = () => {
    setOpen(!open);
  };

  return (
    <Box>
      <Box onClick={onOpen} className={classes.bar}>
        {title}
        <ArrowSVG
          style={{
            transform: open ? 'rotate(180deg)' : '',
            transition: 'transform 200ms ease',
          }}
        />
      </Box>
      <Collapse isOpened={open}>{content}</Collapse>
    </Box>
  );
};

export default ExpansionPanel;
